import CryptoJS from 'crypto-js';

/**
 * AES加密处理（ECB模式）
 */
export function encrypt (keyVlaue, plaintText) {
  console.log(plaintText)
  var options = {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  };
  var key = CryptoJS.enc.Utf8.parse(keyVlaue); //秘钥
  var encryptedData = CryptoJS.AES.encrypt(plaintText, key, options);
  var encryptedBase64Str = encryptedData.toString().replace(/\//g, "_");
  encryptedBase64Str = encryptedBase64Str.replace(/\+/g, "-");
  return encryptedBase64Str;
}

/**
 * AES解密处理（ECB模式）
 */
export function decrypt (keyVlaue, encryptedBase64Str) {
  var vals = encryptedBase64Str.replace(/-/g, '+').replace(/_/g, '/');
  var options = {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  };
  var key = CryptoJS.enc.Utf8.parse(keyVlaue); //秘钥
  var decryptedData = CryptoJS.AES.decrypt(vals, key, options);
  var decryptedStr = CryptoJS.enc.Utf8.stringify(decryptedData);
  return decryptedStr
}